import { BodyInterestedPeopleVM } from 'practice/view-models/practice-detail';
import { HeadCell } from 'shell/components/shared/table/types';

export const headCells: HeadCell<BodyInterestedPeopleVM, keyof BodyInterestedPeopleVM>[] = [
  {
    id: 'fiscalCode',
    label: 'CF',
  },
  {
    id: 'surname',
    label: 'Cognome',
  },
  {
    id: 'name',
    label: 'Nome',
  },
  {
    id: 'aggregateToPractice',
    label: 'Aggregato alla pratica',
  },
  {
    id: 'gender',
    label: 'Sesso',
  },
  {
    id: 'dateBirth',
    label: 'Data di nascita',
  },
  {
    id: 'placeBirth',
    label: 'Luogo di nascita',
  },
  {
    id: 'relationship',
    label: 'Parentela/Legame',
  },
  {
    id: 'licenseValue',
    label: 'Patente',
  },
  {
    id: 'carValue',
    label: 'Auto',
  },
  {
    id: 'aire',
    label: 'AIRE',
  },
  {
    id: 'action',
    label: 'Azioni',
  },
];
